<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<div class="light-container-popup-basic">
	<div class="light-container__header">{{ popupText.headingText }}</div>
	<div *ngIf="popupText.descriptionText" class="light-container__text-block">
		{{ popupText.descriptionText }}
	</div>
	<div class="light-container-popup__footer space-children-h">
		<button
			*ngIf="popupText.customCancelText"
			(click)="writeCancel(); complete()"
			class="legacy-button btn--white"
			automationId="customCancel"
		>
			{{ popupText.customCancelText }}
		</button>
		<button
			*ngIf="popupText.customSaveText"
			(click)="writeOutput(); complete()"
			class="legacy-button btn--blue"
			automationId="customSave"
		>
			{{ popupText.customSaveText }}
		</button>
	</div>
</div>
